import { useState } from 'react';
import { api } from '../api/client';
import { useAuth } from '../contexts/AuthContext';
import { Avatar } from '../components/ui/Avatar';

export function PerfilPage() {
  const { user, refreshUser, logout } = useAuth();
  const [whatsapp, setWhatsapp] = useState(user?.whatsapp || '');
  const [salvando, setSalvando] = useState(false);
  const [msg, setMsg] = useState('');

  const salvar = async (e) => {
    e.preventDefault();
    setSalvando(true);
    setMsg('');
    try {
      await api.patch('/auth/me/whatsapp', { whatsapp });
      await refreshUser();
      setMsg('Salvo!');
    } catch (e) {
      setMsg(e.message);
    } finally {
      setSalvando(false);
    }
  };

  return (
    <div className="page">
      <div className="page-header">
        <div>
          <h1 className="page-title">Meu perfil</h1>
          <p className="page-subtitle">Seus dados de acesso e notificação.</p>
        </div>
      </div>

      <div className="card">
        <div className="card-body stack">
          <div className="row" style={{ gap: 14 }}>
            <Avatar nome={user?.nome} src={user?.foto} size="lg" />
            <div>
              <div className="strong">{user?.nome}</div>
              <div className="muted text-sm">{user?.email}</div>
              <div className="muted text-xs">
                {user?.secretaria_nome || 'Sem secretaria atribuída'} · {user?.perfil}
              </div>
            </div>
          </div>

          <form onSubmit={salvar} className="stack" style={{ gap: 12, marginTop: 10 }}>
            <div className="field">
              <label>WhatsApp (para receber notificações)</label>
              <input
                className="input"
                type="tel"
                placeholder="(37) 99999-9999"
                value={whatsapp}
                onChange={(e) => setWhatsapp(e.target.value)}
              />
              <div className="text-xs muted">DDI 55 é adicionado automaticamente se não informado.</div>
            </div>
            <div className="row-wrap" style={{ justifyContent: 'flex-end', gap: 10 }}>
              <button type="button" className="btn btn-ghost" onClick={logout} style={{ color: 'var(--c-danger)' }}>Sair</button>
              <button type="submit" className="btn btn-primary" disabled={salvando}>
                {salvando ? 'Salvando...' : 'Salvar'}
              </button>
            </div>
            {msg && <div className="text-sm muted">{msg}</div>}
          </form>
        </div>
      </div>
    </div>
  );
}
